import { TextStylePreset, Typography } from '@vivaldis/antd-ui'
import { useMemo } from 'react'
import { EmployeeDetailsQuery_employee_teamCompanies } from '../../../../../graphql/__generated__/EmployeeDetailsQuery'

interface Props {
  teamCompany: EmployeeDetailsQuery_employee_teamCompanies
}

export const Name = ({ teamCompany }: Props) => {
  const companyNameLabel = useMemo(() => {
    // in some cases officialName can be null, so we don't want to show (null)
    if (
      teamCompany.name !== teamCompany.officialName &&
      teamCompany.officialName
    ) {
      return `${teamCompany.name} (${teamCompany.officialName})`
    }

    return teamCompany.name
  }, [teamCompany.name, teamCompany.officialName])

  return (
    <Typography.Text preset={TextStylePreset.Regular14}>
      {companyNameLabel}
    </Typography.Text>
  )
}
